import { Button, Grid, MenuItem, makeStyles } from '@material-ui/core';
import React, { useEffect, useState } from 'react'
import { SelectValidator, TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { fetchConToken } from '../../../helpers/fetch';
import SaveIcon from "@material-ui/icons/Save";
import CancelIcon from "@material-ui/icons/Cancel";

const useStyles = makeStyles({
  botonera: {
      padding: 25
  }
});

export const FormIngresoPisoRecepcion = (props) => {

  const { pisoRecepcion } = props;
  const classes = useStyles();
  const [listaRecepciones, setListaRecepciones] = useState([]);
  const [idRecepcion, setIdRecepcion] = useState(pisoRecepcion?.idRecepcion ? pisoRecepcion?.idRecepcion : 1);
  const [piso, setPiso] = useState(pisoRecepcion?.piso ? pisoRecepcion?.piso : '');

  const handleSave = (e) => {
    e.preventDefault()
    const data = {
      idRecepcion : idRecepcion,
      piso : piso
    }
    props.handleSave(data);
    props.cerrarModal();
};  


useEffect(() => {
  const traerDatos = async () => {
        const response = await fetchConToken(`Totem/Recepciones`);
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
            const lista = await response.json();
            if (lista) {
            let listaFromApi = lista.map((item) => {
                return {
                value: item.id,
                display: item.descripcion,
                };
            });
            setListaRecepciones(listaFromApi);
    }
  }
};
traerDatos();
}, []);



  return (
    <ValidatorForm onSubmit={handleSave} >
            <Grid container style={{ padding: 25 }}>
                <Grid item xs={12} md={6}>
                <SelectValidator
                        margin="normal"
                        label="Recepciones"
                        name="idRecepcion"
                        autoComplete="off"
                        onChange={(e) => setIdRecepcion(e.target.value)}
                        value={idRecepcion}
                        style={{ paddingRight: "0.5rem" }}
                        fullWidth
                        validators={["required",'minNumber:1']}
                        errorMessages={["La recepción es requerida, 'Debe seleccionar una'"]}
                   >
                    <MenuItem value={0}>
                    <em>Seleccione Recepcion</em>
                    </MenuItem>
                    {listaRecepciones.map((pla) => (
                        <MenuItem key={pla.value} value={pla.value}>
                            {pla.display}
                        </MenuItem>
                    ))}
                  </SelectValidator>
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextValidator
                        margin="normal"
                        label="Piso"
                        name="piso"
                        autoComplete="off"
                        value={piso}
                        onChange={(e) => setPiso(e.target.value)}
                        fullWidth
                        style={{ paddingRight: "0.5rem" }}
                        disabled={pisoRecepcion ? true : false}
                        validators={["required"]}
                        errorMessages={["El piso es obligatorio"]}
                    />
                </Grid>
                <Grid container className={classes.botonera} >
                    <Grid item xs={12}>
                        <Grid
                            container
                            spacing={1}
                            direction="row"
                            justify="flex-end"
                            alignItems="center"
                        >
                            <Button
                                variant="contained"
                                color="secondary"
                                size="small"
                                startIcon={<CancelIcon />}
                                onClick={props.cerrarModal}
                            >
                                CANCELAR
                            </Button>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="small"
                                    startIcon={<SaveIcon />}
                                    type='submit'
                                    style={{ marginLeft: "0.5rem" }}
                                    //onClick={props.cerrarModal}
                                >
                                    GUARDAR
                                </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </ValidatorForm>
  )
}

